import { styled } from '@mui/material/styles'
import { Link } from 'react-router-dom'

export default styled(Link)(() => ({
  color: '#1C47CB',
  textDecoration: 'none',
  fontWeight: 600
}))
